import { ActionTypes } from '../../constants'
import { Student } from '../../models/users'

const initialState = {
  object: {},
  processing: false,
  error: null,
  validationErrors: null
}

const castStudent = (object) => {
  return object instanceof Student ? object : new Student(object)
}

const student = (state = initialState, action) => {
  switch(action.type) {
  case ActionTypes._STUDENT_ACTION_REQUEST:
    return { ...state, object: castStudent(action.object), processing: true }

  case ActionTypes._STUDENT_ACTION_SUCCESS:
    return {
      ...state,
      object: castStudent(action.object),
      processing: false,
      error: null,
      validationErrors: null
    }

  case ActionTypes._STUDENT_ACTION_FAILURE:
    const { error, error: { response } } = action
    return {
      ...state,
      processing: false,
      error: /(409|422)/.test(response.status) ? null : action.error,
      validationErrors: /(409|422)/.test(response.status) ? response.data : null
    }
  default:
    return state;
  }
}

export default student
